// removed by extract-text-webpack-plugin
module.exports = {"border":"src-components-modules-ContentBlocks-Social-style----general-module---border---31tW9 bg-smoke","hover":"src-components-modules-ContentBlocks-Social-style----general-module---hover---3m_yO cursor-pointer outline-none scaleUp--hover transitionDuration-m transitionProperty-all transitionTimingFunction-cb--scaleUp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/ContentBlocks/Social/style/general.module.css
// module id = 1442
// module chunks = 33019919093843